export default "__VITE_ASSET__b8aa0d21__"